import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import environment from '../../../../environment/environment';
import { useUser } from '../../../../context/UserContext';

const Sidebar = ({mobile, onClose}) => {
    const logo = environment.logo;
    const location = useLocation();
    const { user } = useUser();

    const userMenuOptions = [
        { url: '/sensors', icon: 'sensors', label: 'Sensores' },
    ];

    const adminMenuOptions = [
        { url: '/simcards', icon: 'sim_card', label: 'Sim cards' },
        { url: '/sensors-ad', icon: 'sensors', label: 'Sensores' },
        { url: '/crops', icon: 'eco', label: 'Cultivos' },
        { url: '/users', icon: 'person', label: 'Usuarios' },
    ];

    return (
        <div className="flex flex-col h-full">
            {mobile &&
                <div>
                    <div className="flex flex-wrap items-center justify-center cursor-pointer relative mt-4">
                        <Link to='/' onClick={onClose}>
                            <Image width={192} height={98} src={logo} className="w-24" />
                        </Link>
                    </div>

                    <hr className="my-6" />
                </div>
            }

            <div className="flex-1">
                <h4 className="text-sm text-black font-bold mb-2">Usuario</h4>
                <ul className="space-y-4 px-2 flex-1">
                    {userMenuOptions.map((menuOption, index) => (
                        <li key={index}>
                            <Link to={menuOption.url} onClick={onClose} className={`
                                flex items-center text-gray-900 text-sm hover:text-blue-600 transition-all no-underline
                                ${location.pathname === menuOption.url ? 'text-green-700 font-bold no-underline' : 'text-gray-900 hover:text-blue-600 no-underline'}
                            `}
                            >
                                <span className={`material-icons-outlined mr-2 ${location.pathname === menuOption.url ? 'text-green-700' : 'text-blue-600' }`}>
                                    {menuOption.icon}
                                </span> {menuOption.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

             {/* Verifica si el usuario tiene ROLE_ADMIN antes de mostrar opciones de administración */}
             {user && user.authorities.includes("ROLE_ADMIN") &&
                <div>
                    <hr className="my-6" />

                    <div className="my-4">
                    
                        <h4 className="text-sm text-black font-bold mb-3">Administración</h4>

                        <ul className="space-y-4 px-2 flex-1">
                            {adminMenuOptions.map((menuOption, index) => (
                                <li key={index}>
                                    <Link to={menuOption.url} onClick={onClose} className={`
                                            flex items-center text-sm transition-all
                                            ${location.pathname === menuOption.url ? 'text-green-700 font-bold no-underline' : 'text-gray-900 hover:text-blue-600 no-underline'}
                                        `}
                                    >
                                        <span className={`material-icons-outlined mr-2 ${location.pathname === menuOption.url ? 'text-green-700' : 'text-blue-600' }`}>
                                            {menuOption.icon}
                                        </span> {menuOption.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            }
        </div>
    );
};

export default Sidebar;